import { useRef } from "react";
import { FileUploadConfig, getSupportedExtensions } from "../fileUpload/fileUploadDomain";
import { Button, ButtonProps, LinkButton } from "./Button";

import { useTranslation } from "../stores/RootStoreContext";
import { TMessage } from "../i18n/tt";

export type SelectFilesButtonProps = {
  fileUploadConfig: FileUploadConfig;
  onChange: (files: File[], fileUploadConfig: FileUploadConfig) => void;
  variant?: ButtonProps["variant"] | "link";
  icon?: ButtonProps["icon"];
  label?: string | TMessage;
  isLoading?: boolean;
  isDisabled?: boolean;
  multiple?: boolean;
  className?: string;
};

export function SelectFilesButton({
  fileUploadConfig,
  onChange,
  variant,
  icon,
  label,
  isLoading,
  isDisabled,
  multiple = true,
  className,
}: SelectFilesButtonProps) {
  const { t } = useTranslation();
  const filesInputRef = useRef<HTMLInputElement>(null);
  return (
    <>
      <input
        type="file"
        ref={filesInputRef}
        className={"tw-hidden"}
        multiple={multiple}
        accept={getSupportedExtensions(fileUploadConfig.supportedFileTypes, {
          leadingDot: true,
        }).toString()}
        onChange={(event) => {
          onChange(event.target.files ? Array.from(event.target.files) : [], fileUploadConfig);
        }}
        onClick={(event) => {
          (event.target as HTMLInputElement).value = "";
        }}
      />

      {variant === "link" ? (
        <LinkButton
          icon={icon ?? "folder"}
          label={label ?? t(multiple ? "select-files" : "select-file")}
          onClick={() => filesInputRef.current?.click()}
          loading={isLoading}
          disabled={isDisabled}
          className={className}
        />
      ) : (
        <Button
          variant={variant ?? "secondary"}
          icon={icon ?? "folder"}
          label={label ?? t(multiple ? "select-files" : "select-file")}
          onClick={() => filesInputRef.current?.click()}
          loading={isLoading}
          disabled={isDisabled}
          className={className}
        />
      )}
    </>
  );
}
